import MainTipos from './MainTipos';
import initialState from '../../store/initialState';

export const ObtenerDatosBasicosReducer = (state = initialState.datosPersona, action) => {
  switch (action.type) {
    case MainTipos.data.VALIDADOR_API_PERSONA:
      return {
        ...state,
        enEjecucionAPIDatosPersona: action.enEjecucionAPIDatosPersona,
      };
    case MainTipos.data.OBTENER_DATOS_PERSONA:
      return {
        ...state,
        enEjecucionAPIDatosPersona: false,
        datosBasicosPersona: action.payload.datosPersona
      };
    case MainTipos.data.GUARDAR_EMAIL_SOCIO:
      return {
        ...state,
        emailSocio: action.payload.email
      };
    default:
      return state;
  }
}

export const UpdateDatosReducer = (state = initialState.updateDatosPersona, action) => {
  switch (action.type) {
    case MainTipos.data.updatePersona.API_UPDATE_PERONA:
      return {
        ...state,
        enEjecucionAPI: action.payload.enEjecucionAPI,
      };
    case MainTipos.data.updatePersona.UPDATE_PERONA:
      return {
        ...state,
        enEjecucionAPI: false,
        updatedatosPersona: action.payload.updatedatosPersona
      };
    case MainTipos.data.updatePersona.ERROR:
      return {
        ...state,
        enEjecucionAPI: false,
        error: action.payload.error,
        updatedatosPersona:false
      };
    default:
      return state;
  }
}

export const ObtenerCampanaReducer = (state = initialState.campanaVigente, action) => {
  switch (action.type) {
    case MainTipos.data.CAMPANA_PENDIENTE:
      return {
        ...state,
        enEjecucionAPICampana: action.payload.enEjecucionAPICampana,
      };
    case MainTipos.data.CAMPANA_EXITOSA:
      return {
        ...state,
        enEjecucionAPICampana: false,
        datos: action.payload.datos
      };
    case MainTipos.data.fecha.INICIO_FECHA_SERVIDOR:
      return {
        ...state,
        enEjecucionObtenerFechaAPI: action.payload.enEjecucionObtenerFechaAPI,
      };
    case MainTipos.data.fecha.OBTENER_FECHA_SERVIDOR:
      return {
        ...state,
        enEjecucionObtenerFechaAPI: false,
        fechaServidor: action.payload.fechaServidor
      };
    case MainTipos.data.GUARDAR_TRACKID:
      return {
        ...state,
        trackId: action.payload.trackId
      };
    case MainTipos.data.CAMPANA_ERORR:
      return {
        ...state,
        enEjecucionAPICampana: false,
      };
    case MainTipos.data.GUARDAR_TOKEN_SOCIO:
      return {
        ...state,
        token: action.payload.token
      };
    case MainTipos.data.GUARDAR_IDFLUJO:
      return {
        ...state,
        idFlujo: action.payload.idFlujo
      };
    default:
      return state;
  }
}

export const ObtenerIndicadorCurse = (state = initialState.indicadorCurse, action) => {
  switch (action.type) {
    case MainTipos.data.indicadorCurse.INICIO_INDICADOR_CURSE:
      return {
        ...state,
        enEjecucionCursarCreditoAPI: action.enEjecucionCursarCreditoAPI,
      };
    case MainTipos.data.indicadorCurse.OBTENER_INDICADOR_CURSE:
      return {
        ...state,
        enEjecucionCursarCreditoAPI: false,
        curse: action.payload.curse
      };
    case MainTipos.data.indicadorCurse.ERROR:
      return {
        ...state,
        enEjecucionCursarCreditoAPI: false
      };
    default:
      return state;
  }
}

export const ObtenerConsultarDetalleDeSolicitud = (state = initialState.consultarSolicitud, action) => {
  switch (action.type) {
    case MainTipos.data.consultarDellateSolicitud.INICIO_CONSULTAR_DETALLE_SOLICITUD:
      return {
        ...state,
        enEjecucionConsultarSolicitudAPI: action.enEjecucionConsultarSolicitudAPI,
      };
    case MainTipos.data.consultarDellateSolicitud.OBTENER_CONSULTAR_DETALLE_SOLICITUD:
      return {
        ...state,
        enEjecucionConsultarSolicitudAPI: false,
        consultarSolicitud: action.payload.detalle
      };
    case MainTipos.data.consultarDellateSolicitud.ERROR:
      return {
        ...state,
        enEjecucionConsultarSolicitudAPI: false
      };
    default:
      return state;
  }
}

export const sessionReducer = (state = initialState.session, action) => {
  switch (action.type) {
    case MainTipos.session.ACTUALIZAR_TRACKID_SESSION:
      return {
        ...state,
        trackId: action.payload.trackId,
      };
    case MainTipos.session.GUARDAR_TOKEN_SOCIO_SESSION:
      return {
        ...state,
        token: action.payload.token,
      };
    case MainTipos.session.ID_FLUJO_SESSION:
      return {
        ...state,
        idFlujo: action.payload.idFlujo,
      };
      case MainTipos.session.REFRES_TOKEN:
        return {
          ...state,
          tokenLive: action.payload.tokenLiveStatus,
        };
    default:
      return state;
  }
}

export const ObtenerSimulacionReducer = (state = initialState.simulacion, action) => {
  switch (action.type) {
    case MainTipos.data.simulacion.INCION_SIMULAR:
      return {
        ...state,
        enEjecucionAPISimulacion: action.payload.enEjecucionAPISimulacion,
      };
    case MainTipos.data.simulacion.OBTENER_SIMULACION:
      return {
        ...state,
        enEjecucionAPISimulacion: false,
        detalleSimulacion: action.payload.detalle,
        estado: true
      };
    case MainTipos.data.simulacion.ERROR_CODE:
      return {
        ...state,
        enEjecucionAPISimulacion: false,
        codeError: action.payload.error_code,
        estado: false
      };
    case MainTipos.data.simulacion.ERROR:
      return {
        ...state,
        enEjecucionAPISimulacion: false
      };
    default:
      return state;
  }
}

export const solicitarReducer = (state = initialState.solicitarCredito, action) => {
  switch (action.type) {
    case MainTipos.data.solicitar.INCION_SOLICITAR:
      return {
        ...state,
        enEjecucionSolicitarAPI: action.payload.enEjecucionSolicitarAPI,
      };
    case MainTipos.data.solicitar.OBTENER_SOLICITAR:
      return {
        ...state,
        enEjecucionSolicitarAPI: false,
        solicitar: action.payload.solicitar
      };
    case MainTipos.data.solicitar.ERROR:
      return {
        ...state,
        enEjecucionSolicitarAPI: false,
        errorSolicitar: true
      };
    default:
      return state;
  }
}


export const enviarSoliciturReducer = (state = initialState.enviarSolicitudDocumentos, action) => {
  switch (action.type) {
    case MainTipos.data.enviarSolicitud.ARCHIVO_ENVIANDO:
      return {
        ...state,
        enEjecucionEnviarSolicitud: action.payload.enEjecucionEnviarSolicitud,
      };
    case MainTipos.data.enviarSolicitud.ARCHIVO_ENVIADO:
      return {
        ...state,
        enEjecucionEnviarSolicitud: false,
        enviarSolicitud: action.payload.enviarSolicitud
      };
    case MainTipos.data.enviarSolicitud.ERROR:
      return {
        ...state,
        enEjecucionEnviarSolicitud: false,
        errorEnviarSolicitud: true
      };
    default:
      return state;
  }
}

export const webViuwReducer = (state = initialState.webViuw, action) => {
  if (action.type === MainTipos.data.webViuw.SET_WEBVIUW) {
    return {
      ...state,
      estado: true
    };
  }
  return state;
}